import React from 'react';
import { Alert } from '@tvg/fuse/alert';

type Props = {
  errorMessage: string;
  dataTestId?: string;
};

function AlertsComponent(props: Props) {
  const { errorMessage, dataTestId } = props;
  return (
    <Alert variant="error" size="small" role="alert" dataTestId={dataTestId || 'error-alert'} message={errorMessage} />
  );
}

export default AlertsComponent;
